<div class="item-map-panel">
  <!--Head-->
  <div *ngIf="linkedItems.size > 0" class="item-map-panel-head">
    <div *ngFor="let item of linkedItems | keyvalue" class="head-item">
      <ng-container *ngTemplateOutlet="linkedItem; context: { item: item.value }"></ng-container>
    </div>
  </div>

  <!--Search-->
  <div class="menu-search mat-mdc-menu-item">
    <craft-icon class="svg-icon search-icon" name="search--search"></craft-icon>
    <input type="text" placeholder="Search items to link" [formControl]="searchControl" class="w-100" />
  </div>

  <div class="item-map-panel-content">
    <ng-container *ngIf="!isLoading; else loading">
      <!--Theme-->
      <div
        *ngFor="let feature of items; trackBy: identify"
        [ngClass]="{ active: openedItems.has(feature.guid) }"
        class="feature parent-item"
      >
        <ng-container *ngTemplateOutlet="notLinkitem; context: { item: feature }"></ng-container>

        <!--Epic-->
        <ng-container *ngIf="openedItems.has(feature.guid)">
          <div
            *ngFor="let epic of feature.children; trackBy: identify"
            [ngClass]="{ active: openedItems.has(epic.guid) }"
            class="epic parent-item"
          >
            <ng-container *ngTemplateOutlet="linkItem; context: { item: epic }"></ng-container>

            <!--Story-->
            <ng-container *ngIf="openedItems.has(epic.guid)">
              <div
                *ngFor="let page of epic.children; trackBy: identify"
                (click)="toggleLinkItem(page, $event)"
                class="story active"
              >
                <ng-container *ngTemplateOutlet="linkItem; context: { item: page }"></ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <craft-preloader customClass="mt-10 sm static"></craft-preloader>
</ng-template>

<ng-template #linkedItem let-item="item">
  <div mat-menu-item="">
    <div class="icons">
      <craft-icon
        matTooltip="Remove linked item"
        matTooltipPosition="above"
        class="svg-icon remove-icon"
        name="general--close-sm"
        (click)="unlinkItem(item)"
      >
      </craft-icon>
      <craft-icon class="svg-icon item-icon" [name]="ICONS[item.itemTypeId]"></craft-icon>
    </div>
    <div class="title-wrap">
      <span class="item-title" title="{{ item.title }}">{{ item.title }}</span>
      <a
        class="link"
        [href]="'product/@productId/item/@itemId' | appUrl: item.productId : item.shortId"
        target="_blank"
        (click)="$event.stopPropagation()"
      >
        <craft-icon class="svg-icon" name="general--viewin-md"></craft-icon>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #notLinkitem let-item="item">
  <div mat-menu-item="" (click)="toggleParent(item)">
    <craft-icon class="svg-icon arrow-icon" name="arrows--arrow-right-b-sm"></craft-icon>
    <span class="item-title" title="{{ item.title }}">{{ item.title }}</span>
  </div>
</ng-template>

<ng-template #linkItem let-item="item">
  <div mat-menu-item="" (click)="toggleParent(item)">
    <div class="icons">
      <craft-icon class="svg-icon arrow-icon" name="arrows--arrow-right-b-sm"></craft-icon>
      <mat-checkbox [checked]="linkedItems.has(item.guid)" (click)="toggleLinkItem(item, $event)" class="small">
      </mat-checkbox>
      <craft-icon class="svg-icon item-icon" [name]="ICONS[item.itemTypeId]"></craft-icon>
    </div>
    <div class="title-wrap">
      <span class="item-title" title="{{ item.title }}">{{ item.title }}</span>
      <a
        class="link"
        [href]="'product/@productId/item/@itemId' | appUrl: item.productId : item.shortId"
        target="_blank"
        (click)="$event.stopPropagation()"
      >
        <craft-icon class="svg-icon" name="general--viewin-md"></craft-icon>
      </a>
    </div>
  </div>
</ng-template>
